export default function HeroSection() {
  return (
    <section className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden px-4 md:px-6">
      <div className="absolute inset-4 md:inset-6 rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Minimal%20elegant%20product%20flat%20lay%20with%20premium%20sneakers%20a%20leather%20bag%20and%20folded%20clothing%20arranged%20on%20light%20linen%20fabric%20surface%20soft%20diffused%20natural%20window%20light%20from%20left%20side%20warm%20cream%20and%20beige%20color%20palette%20clean%20open%20space%20for%20text%20overlay%20on%20right%20side%20editorial%20fashion%20catalog%20photography%20with%20sophisticated%20casual%20aesthetic%20gentle%20shadows%20organized%20harmonious%20composition&width=1600&height=900&seq=hero-bg-v3-001&orientation=landscape"
          alt="Premium fashion and lifestyle products collage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>
      </div>

      <div className="relative z-10 text-center max-w-3xl mx-auto w-full">
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full mb-6 md:mb-8">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide">Trusted Product Sourcing Tool</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6">
          The Ultimate
          <br />
          Mulebuy Spreadsheet
        </h1>

        <p className="text-white/80 text-base md:text-lg font-light max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Discover how a <strong className="text-white font-medium">mulebuy spreadsheet</strong> helps users organize products, compare prices, and streamline sourcing in a simple and efficient system.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
          >
            <span>Explore Mulebuy Spreadsheet Guides</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            Visit Main Website
          </a>
        </div>
      </div>
    </section>
  );
}